class ImageTestimonial extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-image-testimonial-slide]'));
    this.images = Array.from(this.querySelectorAll('[data-image-testimonial-image]'));
    this.prevButton = this.querySelector('[data-image-testimonial-prev]');
    this.nextButton = this.querySelector('[data-image-testimonial-next]');
    this.index = 0;

    if (this.slides.length === 0) return;

    this.onPrev = () => this.show(this.index - 1);
    this.onNext = () => this.show(this.index + 1);
    this.prevButton?.addEventListener('click', this.onPrev);
    this.nextButton?.addEventListener('click', this.onNext);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.onPrev);
    this.nextButton?.removeEventListener('click', this.onNext);
  }

  show(nextIndex) {
    if (nextIndex < 0) nextIndex = this.slides.length - 1;
    if (nextIndex >= this.slides.length) nextIndex = 0;
    this.index = nextIndex;

    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    this.images.forEach((image, index) => {
      const active = index === this.index;
      image.hidden = !active;
      image.classList.toggle('is-active', active);
    });

    this.updateButtons();
  }

  updateButtons() {
    const disabled = this.slides.length <= 1;
    if (this.prevButton) this.prevButton.disabled = disabled;
    if (this.nextButton) this.nextButton.disabled = disabled;
  }
}

if (!customElements.get('image-testimonial')) {
  customElements.define('image-testimonial', ImageTestimonial);
}